// codex.md RBAC: every nav entry carries a `pageKey` that matches a row in
// the PagePermission table (see server/src/seeds/defaultPermissions.ts).
// AppShell filters NAV_ITEMS + ADMIN_NAV_ITEMS through auth.canSeePage()
// before rendering, and route guards use the same key so direct-URL
// navigation is rejected with AccessDenied. pageKey === id in the common
// case; NAV_ALIAS_MAP below pins a few legacy ids to their canonical page.
export const NAV_ITEMS = [
  { id: "dashboard", pageKey: "dashboard", label: "Dashboard",         icon: "◈" },
  { id: "mytasks",   pageKey: "mytasks",   label: "My Tasks",          icon: "✓" },
  { id: "scoping",   pageKey: "scoping",   label: "Scoping & Pipeline", icon: "◉" },
  { id: "projects",  pageKey: "projects",  label: "Delivery",          icon: "▣" },
  { id: "resources", pageKey: "resources", label: "Resources",         icon: "◇" },
  { id: "clients",   pageKey: "clients",   label: "Client Overview",   icon: "◑" },
  { id: "financial", pageKey: "financial", label: "Financial Status",  icon: "◬" },
  { id: "reports",   pageKey: "reports",   label: "Weekly Reports",    icon: "📋" },
  { id: "leads",     pageKey: "leads",     label: "Leads",             icon: "◐" },
  { id: "audits",    pageKey: "audits",    label: "Audits",            icon: "◫" },
  { id: "mentions",  pageKey: "mentions",  label: "Mentions",          icon: "@" },
  { id: "monday",    pageKey: "monday",    label: "Monday Board",      icon: "🔗" },
];

export const ADMIN_NAV_ITEMS = [
  { id: "team",                  pageKey: "team",        label: "Team & Access",    icon: "◎", requiresSuperAdmin: true },
  { id: "audit-task-templates",  pageKey: "audits",      label: "Audit Templates",  icon: "◧" },
  // codex.md RBAC admin UI — matrix of (role × pageKey/graphKey) checkboxes.
  { id: "permissions",           pageKey: "permissions", label: "Permissions",      icon: "🔒", requiresSuperAdmin: true },
];

export const NAV_ALIAS_MAP = {
  deal: "pipeline",
  project: "projects",
  client: "clients",
  "new-client": "clients",
  "new-project": "projects",
  resources: "resources",
};
